<template>
  <div class="container">
    <h3 class="title">{{ $t('currency.fabricLibrary') }}</h3>
    <div class="fabric-library-content">
      <div class="filters f--c">
        <el-cascader
          v-model="categoryIds"
          :options="options"
          :props="{ multiple: true }"
          size="mini"
          @change="e => changeCascader(e)"
          collapse-tags
          style="200px">
          <!-- <template slot-scope="{ data }">
            <span>{{ data.label }}</span>
            <span>({{ data.cn }})</span>
          </template> -->
        </el-cascader>
        <el-input v-model.trim="filters.weightMin" clearable size="mini" placeholder="Min Weight" style="width: 120px;" @blur="pageCurrentChange(1)" @clear="pageCurrentChange(1)" />
        <div>~</div>
        <el-input v-model.trim="filters.weightMax" clearable size="mini" placeholder="Max Weight" style="width: 120px;" @blur="pageCurrentChange(1)" @clear="pageCurrentChange(1)" />
        <el-input v-model.trim="filters.searchContent" clearable size="mini" placeholder="search" style="width: 300px;" @change="handleSearchInput">
          <el-button slot="append" icon="el-icon-search" @click="handleSearchInput"></el-button>
        </el-input>
      </div>
      <div class="fabric-library-box">
        <div class="fabric-library-list f">
          <div v-for="item in list" :key="item.id" class="fabric-item">
            <div class="img pointer" @click="jump(item.fabricId)">
              <oss-img :src="item.kkImageUrl" :width="300" />
            </div>
            <div class="name ellipsis pointer" :title="item.enName" @click="jump(item.fabricId)">{{item.enName}}</div>
            <div class="category ellipsis" :title="item.fullCategoryName">{{item.fullCategoryName}}</div>
            <div class="category">{{item.weight}}{{item.weightUnit}}</div>
          </div>
        </div>
        <div v-if="list.length === 0" style="text-align:center;">No Data</div>
      </div>
      <div style="text-align:right;margin-top:10px" class="bg-white">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[20, 50, 100, 200]"
          :total="total"
          :current-page.sync="filters.pageNumber"
          :page-size="filters.pageSize"
          @current-change="pageCurrentChange"
          @size-change="pageSizeChange"/>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
export default {
  data() {
    return {
      filters: {
        // searchContent: '',
        pageSize: 20,
        pageNumber: 1,
        categoryIds: []
      },
      categoryIds: [],
      list: [],
      total: 0,
      options: []
    }
  },
  created() {
    this.getCategoriesTree()
    this.get3dFabrics()
  },
  methods: {
    get3dFabrics() {
      API.get3dFabrics(this.filters).then(res => {
        if (res.code !== 10000) {
          return this.$message.warning(res.message)
        }
        this.list = res.data.list
        this.total = res.data.total
      })
    },
    getCategoriesTree() {
      API.getCategoriesTree().then(res => {
        this.options = res.data.list.map(item => {
          return {
            label: item.languageList[0].name,
            cn: item.languageList[1].name,
            value: item.id,
            children: item.children.length ? item.children.map(t => ({ label: t.languageList[0].name, cn: t.languageList[1].name, value: t.id })) : undefined
          }
        })
      })
    },
    pageSizeChange(pageSize) {
      this.filters.pageSize = pageSize
      this.get3dFabrics()
    },
    pageCurrentChange(page) {
      this.filters.pageNumber = page
      this.get3dFabrics()
    },
    handleSearchInput() {
      this.pageCurrentChange(1)
    },
    changeCascader(arr) {
      let categoryIds = []
      arr.forEach(t => {
        categoryIds.push(t[t.length - 1])
      })
      this.filters.categoryIds = categoryIds
      this.pageCurrentChange(1)
    },
    jump(fabricId) {
      // 跳转到 nuxt商城 界面中
      window.open(`/fabric-library-detail/${fabricId}`, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 1400px;
  min-width: 1000px;
  margin: 0 auto;
  padding: 15px;
  padding-bottom: 4px;
  .title {
    color: #000;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 15px;
  }
}
.fabric-library-content {
  background-color: #fff;
  padding: 16px 10px 10px 16px;
  .filters {
    margin-bottom: 10px;
    flex-wrap: wrap;
    >div {
      margin-right: 10px;
      margin-bottom: 6px;
    }
    /deep/ .el-input__inner {
      border-radius: unset;
    }
    /deep/ .el-cascader__tags .el-tag {
      max-width: 110px !important;
    }
  }

  .fabric-library-box {
    height: calc(100vh - 220px);
    padding-right: 10px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 6px;
    }
  }
  .fabric-library-list {
    flex-wrap: wrap;
    .fabric-item {
      width: calc((100% - 40px) / 5);
      height: 100%;
      margin-right: 10px;
      padding-bottom: 16px;
      .img {
        width: 100%;
        aspect-ratio: 1 / 1;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      &:nth-child(5n) {
        margin-right: 0;
      }
      .name {
        font-size: 16px;
        margin-bottom: 6px;
      }
      .category {
        font-size: 13px;
        color: #606266;
        margin-bottom: 3px;
      }
    }
  }
}
</style>
